import AcceptConditionsPage from "./AcceptConditionsPage";

export default AcceptConditionsPage;